
/**
 * Expose `Pending`.
 */

module.exports = Pending;

/**
 * Initialize a new `Pending` error with the given message.
 *
 * @param {string} message
 */
function Pending(message) {
  this.message = message;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha/lib/pending.js
 ** module id = 136
 ** module chunks = 1
 **/